import React, { Fragment } from "react";
import { footerFixed, PageLayout } from "../../../Constant";
import {} from '../../../Constant';
import StaffList from "./StaffList";

const StaffContainer = () => {
    return (
        <Fragment>
            <StaffList mainTitle={footerFixed} title={footerFixed} parent={PageLayout} />  
        </Fragment>
    )
}
export default StaffContainer;